import React from 'react';
import PropTypes from 'prop-types';
import { Typography } from '@telus-uds/components-web';
import { SummaryDetail, SummaryCategory, SummaryGroupWrapper } from './css';

const FormSummaryRow = ({
  label,
  value = '',
  isDollarRemove = false,
  convertBoolValueToString = false
}) =>
  ((!!value && value !== 'Null') || typeof value === 'number') && (
    <SummaryGroupWrapper>
      <SummaryCategory>
        <Typography>{label}</Typography>
      </SummaryCategory>
      <SummaryDetail>
        <Typography>
          {Array.isArray(value) && value.length > 0
            ? value.map(item =>
                typeof item === 'object' ? (
                  Object.keys(item).map(itemKey => (
                    <div key={`formSummaryRowItem${itemKey}`}>
                      {item[itemKey]}{' '}
                    </div>
                  ))
                ) : (
                  <div>{isDollarRemove ? item : `$${item}`}</div>
                )
              )
            : convertBoolValueToString && typeof value === 'boolean'
            ? value
              ? 'Yes'
              : 'No'
            : value}
        </Typography>
      </SummaryDetail>
      <div className="clear"></div>
    </SummaryGroupWrapper>
  );

FormSummaryRow.propTypes = {
  label: PropTypes.string.isRequired,
  value: PropTypes.string,
  isDollarRemove: PropTypes.bool,
  convertBoolValueToString: PropTypes.bool
};
export default FormSummaryRow;
